import React, {Dispatch, SetStateAction, useEffect} from "react";
import {ChevronDown, ChevronUp, TrendingUpDown} from "lucide-react";
import {Tooltip, TooltipContent, TooltipTrigger} from "../../ui/tooltip";
import {Transform} from "./TransformSelector";
import {cn} from "components/ui/lib/utils";

interface TransformAttributeToggleProps {
    transforms: Transform[];
    isVisible: boolean;
    setIsVisible: Dispatch<SetStateAction<boolean>>,
    alwaysShowBorder: boolean
}

/**
 * TransformAttributeToggle component
 *
 * This component is responsible ONLY for toggling the visibility of transform attribute sections. it only controls whether the UI for
 * editing transform attributes is visible or hidden.
 */
export function TransformAttributeToggle(props: TransformAttributeToggleProps) {

    useEffect(
        () => {
            // If the transform functions are empty, set the visibility to false
            if (props.transforms == undefined || props.transforms.length === 0) {
                props.setIsVisible(false);
            }
        },
        [props.transforms])


    // If no transforms then do not show the toggle button.
    if (props.transforms == undefined || props.transforms.length === 0) {
        return null
    }

    const transformFunctionsCount = props.transforms.length

    return (
        <div
            className={cn("bg-backgrounddark border-border flex flex-col justify-center items-center text-center text-textmedium p-2", props.alwaysShowBorder ? "border-r" : !props.isVisible && "border-r")}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div
                        className={"flex items-center cursor-pointer p-1 rounded"}
                        onClick={() => {
                            props.setIsVisible((prevState) => !prevState);
                        }}
                    >
                        <span className="text-sm font-medium mr-1 flex items-center">
                            <div
                                className={"text-xs bg-secondarytransparenter h-[20px] w-[20px] border border-secondary rounded flex flex-col justify-center content-center mr-2"}>
                            <div className={"flex justify-center items-center"}>
                                {transformFunctionsCount}
                            </div>
                            </div>
                            <TrendingUpDown className={"w-4 h-4"}/>
                        </span>
                        {props.isVisible ? (
                            <ChevronUp className="h-4 w-4"/>
                        ) : (
                            <ChevronDown className="h-4 w-4"/>
                        )}
                    </div>
                </TooltipTrigger>
                <TooltipContent className={"text-textmedium w-[250px]"}>
                    Toggle attribute transform function visibility. This allows you to show or hide the transform
                    attribute section.
                </TooltipContent>
            </Tooltip>
        </div>
    );
}
